import { computed } from '@preact/signals';
import type { GameVoiceBridge } from '../game/contract';
import type { VoiceController } from './types';

/** The part of the voice chat the game screen needs (in-game mic button, speaking marks). */
export function createGameVoiceBridge(voice: VoiceController): GameVoiceBridge {
  return {
    muted: voice.muted,
    micAvailable: voice.micAvailable,
    micLost: computed(() => {
      const permission = voice.micPermission.value;
      return (
        voice.enabled.value &&
        !voice.micAvailable.value &&
        !voice.micRequesting.value &&
        permission !== 'denied' &&
        permission !== 'unsupported'
      );
    }),
    speaking: voice.speaking,
    toggleMute: () => voice.toggleMute(),
    retryMic: () => void voice.enable(),
  };
}
